/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
*/

/**
 * @module bulb-progress/bulb-upload/bulbuploadcommand
 */

import { Command, type ModelWriter, type ModelElement } from 'ckeditor5';
import { assetInsertLocation } from '../../utils';

/**
 * The bulb attached file command, the actual insert capabilities of the plugin.
 *
 * @extends Command
 */
export class BulbInsertUploadPlaceholderCommand extends Command {

  public override execute(uploadDetails): void {
    this.editor.model.change((writer: ModelWriter) => {
      assetInsertLocation(this.editor);
      this.editor.model.insertContent(this.createBulbUploadPlaceholderBlock(writer, uploadDetails));
    });
  }

  public override refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'bulbUploadPlaceholder');

    this.isEnabled = allowedIn !== null;
  }

  /**
   * Helper method to create our custom bulb upload placeholder in the editor's model.
   *
   * @param writer ModelWriter instance from editor to update model.
   * @param uploadDetails Details about the upload.
   * @returns {*}
   */
  private createBulbUploadPlaceholderBlock(writer: ModelWriter, uploadDetails): ModelElement {
    return writer.createElement('bulbUploadPlaceholder', {
      'asset-type': uploadDetails.uploadData.entry.type,
      'asset-id': uploadDetails.uploadData.entry.id,
      'asset-name': uploadDetails.uploadData.entry.name,
      'upload-succeeded': !!(uploadDetails),
    });
  }
}
